import React, { useEffect, useRef } from 'react';
import socketService from '../../services/SocketService';
import { Toast } from 'primereact/toast';


const SocketNotifications = () => {
    const toast = useRef(null);


    const truncateMessage = (message, maxLength = 200) => {
        return message.length > maxLength 
            ? message.substring(0, maxLength) + '...'
            : message;
    };
    

    useEffect(() => {
        // Connect to Socket.IO server
        socketService.connect();
        
        const notificationEvent = (eventType) => { 
             socketService.addListener(eventType, (payload) => {
                 if (payload.type === 'NEW_PORTAL_SUBMISSION') {
                     const toastMessage = `New Portal submission from ${payload.incident.region}: ${payload.incident.eventdescription}`
                     const newmsaage = truncateMessage(toastMessage);
                     showNotification(newmsaage, "Portal Submission");
                     
                }
                 if (payload.type === 'NEW_INCIDENT') {
                     const toastMessage = `New Incident from ${payload.incident.region} NO: ${payload.incident.incidentnumber}: ${payload.incident.eventdescription}`
                     const newmsaage = truncateMessage(toastMessage);
                     showNotification(newmsaage, "Incident from FOH");
                    
                }
                 if (payload.type === 'NEW_SMS_SUBMISSION') {
                     const toastMessage = `New SMS from ${payload.incident.phone} : ${payload.incident.content}`
                     const newmsaage = truncateMessage(toastMessage);
                     showNotification(newmsaage, "SMS");
                     console.log("newmsaage", newmsaage);
                    
                }
                 if (payload.type === 'NEW_WHATSAPP_SUBMISSION') {
                     const toastMessage = `New SMS from ${payload.incident.phone} : ${payload.incident.content}`
                     const newmsaage = truncateMessage(toastMessage);
                     showNotification(newmsaage, "Whatsapp");
                     console.log("newmsaage", newmsaage);
                    
                }
            });
        }

        // Set up event listeners
        notificationEvent('smsincident:created');
        notificationEvent('monitorincident:created');
        notificationEvent('portalincident:created');
        notificationEvent('whatsappincident:created');
      
        // Cleanup on unmount
        return () => {
            socketService.disconnect();
        };
    }, []);


    const showNotification = (message,type) => {
        toast.current.show({
            severity: 'success',
            summary: `NOTIFICATION: New ${type}`,
            detail: message,
            life: 8000
        });

       
    };

    return (
        <Toast ref={toast} position="top-right" /> // Add Toast component
    );
};

export default SocketNotifications;